import axios from "axios";
import { isPublicIsolatedPath } from "../lib/publicIsolatedPaths";
import { isBrowserOffline, isNetworkError } from "../lib/networkStatus";

export const TRIAL_EXPIRED_EVENT = "glossa:trial-expired";

const api = axios.create({
  // baseURL: "http://salonify/api",
  //baseURL: "http://salonify.test/api",
  baseURL: "https://salonify.co.uk/api",
  withCredentials: true,
});

// Request interceptor - Add token to headers
api.interceptors.request.use(
  (config) => {
    // Public onboarding / forms must never send tenant auth token.
    if (isPublicIsolatedPath()) {
      return config;
    }
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor - Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isPublicIsolatedPath()) {
      return Promise.reject(error);
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.code === "TRIAL_EXPIRED"
    ) {
      const payload = {
        message:
          error.response?.data?.message ||
          "Your trial has ended. Please contact support.",
        trial_ends_at: error.response?.data?.trial_ends_at || null,
      };
      window.dispatchEvent(
        new CustomEvent(TRIAL_EXPIRED_EVENT, { detail: payload }),
      );
    }

    if (error.response?.status === 401) {
      // Stay signed in when offline/network failed — only logout on real 401 responses.
      if (isBrowserOffline() || isNetworkError(error)) {
        return Promise.reject(error);
      }

      // Don't log out when impersonate fails (invalid PIN) - let the caller handle the error
      const isImpersonateRequest = error.config?.url?.includes(
        "/admin/impersonate",
      );
      if (isImpersonateRequest) {
        return Promise.reject(error);
      }
      // Token expired or invalid
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Redirect to login only if not already on login page
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
